import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../services/auth-service.service';

/**
 * Shown instead of the portal when an account is already deactivated at sign-in.
 *
 * Standalone on purpose - no guards, no navbar. A user who lands here has a valid B2C session but
 * no access to anything, so the shell would only offer menus that all fail.
 */
@Component({
  selector: 'app-account-deactivated',
  templateUrl: './account-deactivated.component.html',
  styleUrls: ['./account-deactivated.component.scss']
})
export class AccountDeactivatedComponent implements OnInit {

  constructor(
    private msalService: MsalService,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    // Arriving here interrupts the sign-in the overlay was covering, so make sure it is gone -
    // a spinner left spinning over this message would read as "still working on it".
    this.spinner.hide();

    // Ends the session while keeping the browser here: clearCache() is local-only, unlike
    // logoutRedirect(), which would navigate to B2C and take this explanation off screen.
    // Runs on every arrival, so refreshing the page cannot leave a usable token behind.
    this.msalService.instance.clearCache()
      .catch(error => console.error('Could not clear the MSAL cache', error));
  }

  /** Full sign-out, so the B2C session cookie goes too and the next visit starts clean. */
  backToSignIn(): void {
    try {
      this.authService.logout('/login');
    } catch (error) {
      console.error('Sign-out failed; navigating locally instead', error);
      window.location.href = '/login';
    }
  }
}
